var Eyes = {
  LEFT: 0,
  RIGHT: 1
};

module.exports = Eyes;
